<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

@if (resourceService) {
  <div class="resource-dropdown">
    <div class="p-field">
      <p-floatLabel variant="on">
        <bs-autocomplete
          bsFloatLabelCompat
          inputId="resource"
          [ngModel]="selectedResource"
          (ngModelChange)="selectedResource = $event"
          [items]="resources()"
          [dropdown]="true"
          [requireSelection]="true"
          [disabled]="disabled"
          [minLength]="0"
          [displayWith]="getDisplayLabel"
          [compareWith]="compareByIdField"
          (queryChange)="onQueryChange($event)"
          (opened)="onQueryChange('')"
          (selected)="onSelect()"
          (cleared)="onClear()"
          (blurred)="onBlur()" data-testid="selected-resource-autocomplete">
          <ng-template bsItem let-item>
            <span>{{ getDisplayLabel(item) }}</span>
          </ng-template>
        </bs-autocomplete>
        @if (label) {
          <label for="resource">{{ label }}</label>
        }
      </p-floatLabel>
    </div>
  </div>
} @else {
  <p>No resource service for provided resource type</p>
}




